import { AddressLocation } from '@user/components/HereMap/HereMapNew/hooks/useHereMapInstance'

const normalize = (str?: string) => (str ?? '').toLowerCase().trim()

const safeCompare = (a?: string, b?: string) => normalize(a) === normalize(b)

export const isSameAddress = (
  a?: AddressLocation,
  b?: AddressLocation,
): boolean => {
  if (!a || !b) return false

  const streetMatch = safeCompare(a.street1, b.street1)
  const cityMatch = safeCompare(a.city, b.city)
  const stateMatch = safeCompare(a.stateAbbreviation, b.stateAbbreviation)
  const postalMatch = safeCompare(a.postalCode, b.postalCode)

  return streetMatch && cityMatch && (stateMatch || postalMatch)
}

/**
 * Tolerance, in degrees, for treating two map coordinates as the same physical spot
 * (~28 m). A rooftop coordinate from a reverse geocode and the coordinate a pin was
 * geocoded to independently rarely agree exactly.
 */
export const SAME_SPOT_COORD_EPSILON = 0.00025

/** Whether two coordinates are close enough to be the same physical spot. */
export const isSameCoordinate = (
  aLatitude?: number,
  aLongitude?: number,
  bLatitude?: number,
  bLongitude?: number,
): boolean =>
  aLatitude != null &&
  aLongitude != null &&
  bLatitude != null &&
  bLongitude != null &&
  Math.abs(aLatitude - bLatitude) <= SAME_SPOT_COORD_EPSILON &&
  Math.abs(aLongitude - bLongitude) <= SAME_SPOT_COORD_EPSILON
